import { render, staticRenderFns } from "./ShareById.vue?vue&type=template&id=38f6d295&"
import script from "./ShareById.vue?vue&type=script&lang=js&"
export * from "./ShareById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports